<script lang="ts">
	//Design system components
	import {
		ActionsContainer,
		AdvancedCard,
		AdvancedCardV2,
		IconButton,
		Select,
	} from '@Shelly/shelly-design-system';

	//Svelte hooks
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	//Components
	import WizzardWrapperTrvSchedules from '../../../../components/ModalWizzard/WizzardWrapperTrvSchedules.svelte';

	import ProfileName from './ProfileName.svelte';

	export let profileOptions, profileName, disabled;
	export let useNewLayout = false;
	let selectedProfile = profileOptions.indexOf(profileName);
	const dispatch = createEventDispatcher();
	let showModal = false;
	let editableObject = { profileOptions, profileName };
	const handle_profile_change = (e) => {
		selectedProfile = profileOptions.indexOf(e.detail);
		profileName = profileOptions[selectedProfile];

		dispatch('profileChange', {
			selectedProfile,
		});
	};

	const toggle_edit = () => {
		showModal = true;
	};

	const handle_name_save = () => {
		let options = profileOptions;
		options.splice(profileOptions.indexOf(profileName), 1, editableObject.profileName);
		profileOptions = options;
		profileName = editableObject.profileName;

		dispatch('changedName', {
			profileOptions,
			profileName,
		});
	};

	const wizardItems = [
		{
			active: true,
			activeIndex: 0,
			disabled: false,
			showMoreDots: false,
			stepNumber: 1,
			title: '',
			tooltipTitle: $format('change_profile_name'),
			component: ProfileName,
		},
	];
</script>

{#if useNewLayout}
	<AdvancedCardV2 class="mb-s pr-m pl-m" title="" hideSlotTitle={false}>
		<Select
			width="full"
			icon={'fas fa-user'}
			options={profileOptions}
			bind:value={profileName}
			on:change={handle_profile_change}
			slot="main"
			aria-label={$format('label_profile_name', { default: 'Profile name' })}
			id="select-yw64e8h"
		/>
		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				{disabled}
				icon="fas fa-pen"
				on:click={toggle_edit}
				slot="first"
				aria-label={$format('button_edit', { default: 'Edit' })}
			/>
		</ActionsContainer>
	</AdvancedCardV2>
{:else}
	<AdvancedCard class="mb-s d-flex align-items-center" title="" hideSlotTitle={false}>
		<Select
			icon={'fas fa-user'}
			options={profileOptions}
			bind:value={profileName}
			on:change={handle_profile_change}
			slot="main"
			aria-label={$format('label_profile_name', { default: 'Profile name' })}
			id="select-yw64e8h"
		/>
		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				{disabled}
				icon="fas fa-pen"
				on:click={toggle_edit}
				slot="first"
				aria-label={$format('button_edit', { default: 'Edit' })}
			/>
		</ActionsContainer>
	</AdvancedCard>
{/if}

<!-- For UX/UI discussion -->
{#if showModal}
	<WizzardWrapperTrvSchedules
		wizardContentClasses="pl-0 pr-0"
		bind:showModal
		title={$format('label_profile_name', { default: 'Profile name' })}
		{wizardItems}
		callback={handle_name_save}
		bind:editableObject
	/>
{/if}
